import { useEffect } from "react";
import HeroSection from "../components/HeroSection";
import CompanySection from "../components/Company";
import AboutUs from "../components/AboutUs";
import ChooseUs from "../components/ChooseUs";
import Features from "../components/Features";
import Testimonials from "../components/Testimonials";
import Newsletter from "../components/Newsletter";

const Home = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <main>
      <HeroSection />
      <CompanySection />
      <AboutUs />
      <ChooseUs />
      <Features />
      <Testimonials />
      <Newsletter />
    </main>
  );
};

export default Home;
